import { toHaveDisplayValue } from "@testing-library/jest-dom/matchers";
import BaseListPage from "../../../../base/BaseListPage";
import PageContainer from "../../../../components/PageContainer/PageContainer";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../../usecases/object";
import withRouter from "../../../../utils/withRouter";
import AccessHistoryListPresenter from "./AccessHistoryListPresenter";
import Table from "../../../../components/Table";
import { formatDateTime } from "../../../../utils/dateFormat";

class AccessHistoryListPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.state = {
      objects: [],
      selected: [],
      loading: false,
      total: 0,
      count: 0,
    };
    this.presenter = new AccessHistoryListPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      upsertUseCase(),
      deleteObjectUseCase(),
    );

    this.fieldsToDisplay = ["createdAt", "accessor"];
  }

  componentDidMount() {
    this.presenter.componentDidMount();
  }

  getCollectionName() {
    return "access_history";
  }

  formatFields(fields) {
    const { accessor, ...rest } = fields;

    return {
      ...rest,
      affiliate: {
        ...fields.accessor.affiliate,
        type: "String",
      },
      branch: { ...fields.accessor.branch, type: "String" },
      username: {
        ...fields.accessor.username,
        _type: "String",
      },
      createdAt: {
        ...fields.createdAt,
        type: "String",
        label: "Date Accessed",
      },
    };
  }

  formatObjects(objects) {
    return objects.map((object) => {
      const { accessor } = object;

      return {
        ...object,
        affiliate: accessor.affiliate.name,
        branch: accessor.branch.name,
        username: accessor.username,
        createdAt: formatDateTime(object?.createdAt),
      };
    });
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { objects, loading, count } = this.state;

    console.log(objects);

    return (
      <PageContainer
        title="Access History"
        navigateBack={this.navigateBack.bind(this)}
        infiniteScroll={{
          loadMore: this.loadMore.bind(this),
          hasMore: !loading && count > objects.length,
        }}
      >
        <Table
          fields={this.formatFields(schema.fields)}
          objects={this.formatObjects(objects)}
          progress={loading}
          excludeFields={Object.keys(schema.fields).filter(
            (key) => !this.fieldsToDisplay.includes(key),
          )}
        />
      </PageContainer>
    );
  }
}
export default withRouter(AccessHistoryListPage);
